import { DatePicker } from "antd";
import 'antd/dist/antd.min.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import axios from 'axios';
import moment from 'moment';
import propTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { LinkContainer } from 'react-router-bootstrap';
import { Link } from 'react-router-dom';
import { getBarBookings, getBars } from '../../actions/bar';
import { url } from "../../utils/api";
import Loader from '../layout/Loader';
import BarCarousel from './BarCarousel';

AOS.init({
  duration: 1200,
});

const Bar = ({auth: { user, isAuthenticated}, getBars, bar: {bars}, getBarBookings}) => {

  useEffect(() => {
    getBars();
  }, [getBars]);

  useEffect(() => {
    getBarBookings();
  }, [getBarBookings]);

  const [availableBars, setAvailableBars] = useState(bars);
  const [allBars, setAllBars] = useState([]);
  const [date, setdate] = useState('')
  const [loading, setloading] = useState(false);

  function filterByDate(date) {
    setdate(moment(date).format('DD-MM-YYYY'));

    var temp = [];

    for(const bar of allBars) {
      var availability = false;
      if (bar.currentbookings.length > 0) {
        for(const booking of bar.currentbookings){
          if(bar.currentbookings.length){
            var bookedDate = booking.dateon.toString();
            var selectedDate = (moment(date).format('DD-MM-YYYY')).toString();
            if(bookedDate !== selectedDate){
              availability = true;
            }
          }
        }
        if(availability === true || bar.currentbookings.length === 0) {
            temp.push(bar);
        }
        setAvailableBars(temp);
      } else {
        setAvailableBars(bars);
      }
    }
  }

  useEffect(() => {
      const loadBars = async () => {
        setloading(true);
        const bars = await(await axios.get(`${url}/api/bar`)).data;
        //console.log(bars);
        setAvailableBars(bars);
        setAllBars(bars);
        setloading(false);
      }
      loadBars(); //eslint-disable-next-line
  }, []); 
  
  return (
    <>
        <BarCarousel/>
        <div className='container'>
          {isAuthenticated && user && user.usertype === 'guest' &&
          <div style={{textAlign: 'right'}}>
              <Link to='/barbookings'><button type="button" class="btn btn-warning">Your Bar Bookings</button></Link>
          </div>
          }
          <div className="row bs p-3 m-5 dark" data-aos="fade-up">
            <div className="col-md-6">
              <h5 style={{marginTop: '10px'}}>Select Date</h5>
            </div>
            <div className="col-md-6">
              <DatePicker style={{ height: "38px", width: "98%" }} onChange={filterByDate} format='DD-MM-YYYY' className='m-2' />
            </div>
        </div>

        <div className="row justify-content-center mt-5"  >
            {loading ? (
                <Loader />
            ) : (
                <div className="col-md-9 mt-2">
                    {availableBars.map((bar) => (
                        <div className='row bs' key={bar._id} data-aos='zoom-in'>
                            <div className='col-md-4'>
                                <img src={bar.imageurl[0]} alt = 'bar img'></img>
                            </div>
                            <div className='col-md-7'>
                                <h4>{bar.name}</h4>
                                <div style={{ float: 'right', paddingLeft: '14px' }}>
                                    {date && isAuthenticated && user && user.usertype === 'guest' && (
                                        <LinkContainer to={`/bookbar/${bar._id}/${date}`}>
                                          <button className='btn btn-outline-success'>Book Now</button>
                                        </LinkContainer>)
                                    }
                                    {date && !isAuthenticated && (
                                        <Link to='/guestLogin'>
                                          <button className='btn btn-outline-success'>Login to Book</button>
                                        </Link>)
                                    }
                                </div>
                                
                                <div style={{ float: 'right', paddingLeft: '14px' }}>
                                    <LinkContainer to={`/bar/${bar._id}`}>
                                      <button className='btn btn-outline-warning'>More Info</button>
                                    </LinkContainer>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>

        <hr style={{paddingTop: '20px', paddingBottom: '20px'}}/>
        </div>
    </>
  )
};

Bar.propTypes = {
    auth: propTypes.object.isRequired,
    bar: propTypes.object.isRequired,
    getBars: propTypes.func.isRequired,
    getBarBookings: propTypes.func.isRequired
};

const mapStateToProps = state => ({
    auth: state.auth,
    bar: state.bar
});

export default connect(mapStateToProps, {getBars, getBarBookings})(Bar);